/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Commission_Card_Quarter_PendingInputs */



/**
* | output |
* | --- |
* | "Pending this quarter" |
*
* @param {Partner_Commission_Card_Quarter_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_commission_card_quarter_pending = /** @type {((inputs?: Partner_Commission_Card_Quarter_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Commission_Card_Quarter_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Offen in diesem Quartal")
	return /** @type {LocalizedString} */ ("Pending this quarter")
});